import axios from '../base.js'

export default class Page1 {
  static async getData(params) {
    let res = await axios.get('/data/all/深圳地点.json');
    return res.data;
  }
}